import React, { useCallback } from 'react';
import {
  createStyles,
  makeStyles,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import copyToClipboard from 'copy-to-clipboard';

import { Action } from '../../../components';
import { notify } from '../../../store/modules/notifications/actions';
import { Project } from '../../../types/items';
import ClipboardIcon from '../../../assets/icons/clipboard.svg';
import RouteGetter from '../../../routes/RouteGetter';

type Props = {
  project: Project;
};

const useStyles = makeStyles(() => createStyles({
  icon: {
    width: 18,
    height: 20,
  },
}));

export const getProjectInfo = (project: Project) => {
  const { user } = project.ref.project_info;

  return `
Project:\n${project.title}\n
URL:\n${window.location.origin}${RouteGetter.get('project').overview(project.id)}\n
Name:\n${user.full_name_first_last || 'unknown'}\n
Title:\n${user.title || ''}\n
License:\n${user.license || ''}\n
Organization:\n${project.ref?.organization?.common_name}\n
City, State, Zip:\n${user.city || 'unknown'}, ${user.state || 'unknown'}, ${user.zip_code || 'unknown'}\n
Phone:\n${user.phone || 'unknown'}\n
Editor Notes:\n${user.editor_notes}\n
`;
};

const CopyProjectInfoAction = ({ project }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    const projectInfo = getProjectInfo(project);
    if (copyToClipboard(projectInfo, { format: 'text/plain' })) {
      dispatch(notify({
        type: 'success',
        icon: 'copy',
        message: 'Project info copied.',
      }));
    } else {
      dispatch(notify({
        type: 'error',
        icon: 'copy',
        message: 'Copying failed.',
      }));
    }
  }, [dispatch, project]);

  return (
    <Action
      title="Copy project info"
      icon={<img src={ClipboardIcon} className={classes.icon} alt="" />}
      onClick={onClick}
    />
  );
};

export default CopyProjectInfoAction;
